// cssをインポート
import "../../node_modules/destyle.css/destyle.css";

import "../sass/style.scss";

require('./common');
